module.exports = __webpack_public_path__ + "img/work_from_office3.a2cf14b8.png";